import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { statementStages } from '../../utils/enums';

import './StatementStatus.scss';

/**Localized status text and icon
 * @param {object} props Incoming JSX attributes.
 * @param {string} [props.className] A string value that should be a class string delimited by spaces for the purposes of overriding style and functionality in parent components.
 * @param {number} props.status An integer value that corresponds to a status enumeration.
 * @returns {JSX.Element} Localized status text and icon
 * @see {@link https://bitbucket.org/pcgeducation/shipyard/src/master/shipyard-web/src/components/shared/Status.md Status Documentation} for further information
 */

export default function StatementStatus(props) {
    const [circleColor, setCircleColor] = useState(() => {
        if (typeof props?.status === 'number') {
            let _circleColor;

            switch (statementStages[props.status]) {
                case 'StmtStages.NotStarted':
                    _circleColor = 'grey';
                    break;
                case 'StmtStages.Created':
                    _circleColor = 'lightblue';
                    break;
                case 'StmtStages.Submitted':
                    _circleColor = 'green';
                    break;
                case 'StmtStages.Approved':
                    _circleColor = 'blue';
                    break;
                default:
                    _circleColor = 'red';
                    break;
            }
            return _circleColor;
        }
    });

    useEffect(() => {
        setCircleColor(() => {
            if (typeof props?.status === 'number') {
                let _circleColor;

                switch (statementStages[props.status]) {
                    case 'StmtStages.NotStarted':
                        _circleColor = 'grey';
                        break;
                    case 'StmtStages.Created':
                        _circleColor = 'lightblue';
                        break;
                    case 'StmtStages.Submitted':
                        _circleColor = 'green';
                        break;
                    case 'StmtStages.Approved':
                        _circleColor = 'blue';
                        break;
                    default:
                        _circleColor = 'red';
                        break;
                }
                return _circleColor;
            }
        });
    }, [props.status]);

    const circleJSX = <span className={circleColor + ' circle'} />;

    return (
        <span className={props?.className ? props.className + ' statement-status-component' : 'statement-status-component'}>
            {circleJSX}&nbsp;{t(statementStages[props.status])}
        </span>
    );
}
